import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-t_top",
  "use": "icon-t_top-usage",
  "viewBox": "0 0 16 19",
  "content": "<symbol viewBox=\"0 0 16 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-t_top\">\n<path id=\"icon-t_top_&#229;&#189;&#162;&#231;&#138;&#182;&#231;&#187;&#147;&#229;&#144;&#136;\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.64439 1.37543C8.84908 0.226659 7.15092 0.226658 6.35562 1.37543L1.17275 8.86179C0.254434 10.1883 1.20381 12.0002 2.81714 12.0002H5.5V17.0002C5.5 18.1048 6.39543 19.0002 7.5 19.0002H8.5C9.60457 19.0002 10.5 18.1048 10.5 17.0002V12.0002H13.1829C14.7962 12.0002 15.7456 10.1883 14.8273 8.86179L9.64439 1.37543Z\" fill=\"#68A871\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/t_top.svg
// module id = EgvL
// module chunks = 103